export { compare, applyPatch, } from "./fast-json-patch/index.js";
